// Programmatic entry to the Guru dock from anywhere in the app.
//
//   openAgentChat({ prompt, clientId, context, send })
//
//   prompt    text to put in the composer, or to send at once when send=true
//   clientId  which client the question is about (optional; the dock keeps
//             its current client when omitted)
//   context   { card, scope, figures } describing the card the user clicked
//             from — the dock attaches it to the next message as page_context
//             so the answer is about the number in front of them
//   send      true to send immediately; default false (prefill and focus)
//
// The dock is mounted once at the layout level and listens for this event,
// so callers don't need a context provider or a ref.
export const AGENT_CHAT_OPEN_EVENT = 'lg:agent-chat:open';

export function openAgentChat(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AGENT_CHAT_OPEN_EVENT, { detail }));
}

// [['Spend', '$12,811'], ['Pacing', '89.7%']] → { Spend: '$12,811', Pacing: '89.7%' }
// Blank values are dropped so a card can pass its whole row without checks.
export function figuresFrom(entries) {
  const out = {};
  (entries || []).forEach(([key, value]) => {
    if (!key || value === null || value === undefined || value === '') return;
    out[key] = String(value);
  });
  return out;
}
